import React from 'react';
import { connect, useDispatch   } from "react-redux";
import './DealOfTheMonth.scss';
import Product from './Product';  
import ModalProduct from './ModalProduct';  
import { setCurrentProduct } from '../../redux/Order/order.actions';
import { dealOfTheMonthArr } from '../../helpers/productSorters';
import logo from '../Logo/logo.svg';
import { useTranslation } from 'react-i18next';

const mapStateToProps = (state) => ({
  productsObj: state.product.balls,
})

function DealOfTheMonth(props) {

  const { events,products,changeSelectedProduct,windowType } = props;

  const dispatch = useDispatch();

	const dotmArr = dealOfTheMonthArr(props.productsObj);

  const { t, i18n } = useTranslation();

	if (dotmArr.length > 0) {

		return (
				<div className="dotm-box">
					<div className="dotm-container">
						<div className="row py-4 my-2 container-fluid">
							<div className="col-lg-6">
								<div className="dotm-head-container">
									<div className="dotm-image-container">
										<img src={logo} />
									</div>
									<h3 className="dotm-head">{t('DEAL OF THE MONTH')}</h3>
								</div>
							</div>
							<div className="col-lg-5">
							{ dotmArr.map((prod)=>{
								return windowType ==='standard' 
											? 
			  		  		       <Product changeSelectedProduct={changeSelectedProduct} events={events} product={prod} key={prod.ID} />
			  		  		    :
			  		  		       <ModalProduct changeSelectedProduct={changeSelectedProduct} events={events} product={prod} key={prod.ID} />

			  		  	})
							}
						</div>
						</div>
					</div>
				</div>
		)
	}
}

export default connect(mapStateToProps)(DealOfTheMonth)